import type React from 'react';

function HorseonlineIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 945.75 945.75"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Horse Online Icon</title>

      <g id="Lager_1-2" data-name="Lager 1">
        <path
          d="M259.56,204.93v467.13l226.09-166.22,157.09,157.62L239.01,945.75,48.16,806.75V204.93h211.41ZM388.59,1.21c300.96,0,479.46,186.31,479.46,499.71h0v444.83h-224.24v-405.83c0-210.86-109.17-336.51-292.1-336.51h-94.42L41.9,1.21H388.59Zm471.73,24.56v11.33h-18.47v49.97h-13.55V37.1h-18.47v-11.33h50.49Zm26.15,0l14.41,42.16h.17l13.64-42.16h19.08v61.31h-12.69V43.62h-.17l-15.11,43.45h-10.44l-15.1-43.02h-.17v43.02h-12.69V25.76h19.08Z"
          fill="inherit"
        />
        <rect width="945.75" height="945.75" fill="none" />
      </g>
    </svg>
  );
}

export default HorseonlineIcon;
